'use client'

import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'
import classNames from 'classnames'
import { RocketLaunchIcon } from '@heroicons/react/24/outline'

type ExploreNavProps = {
  className?: string
}

const ExploreNav = ({
  className,
}: ExploreNavProps) => {
  const { t } = useTranslation()
  const selectedSegment = useSelectedLayoutSegment()
  const actived = selectedSegment === 'train'

  return (
    <Link href="/train/tasks" className={classNames(
      className, 'group',
      actived && 'bg-white shadow-md',
      actived ? 'text-primary-600' : 'text-gray-500 hover:bg-gray-200',
    )}>
      {
        actived
          ? <RocketLaunchIcon className='mr-2 w-4 h-4' />
          : <RocketLaunchIcon className='mr-2 w-4 h-4' />
      }
      {t('train.title')}
    </Link>
  )
}

export default ExploreNav
